import React from 'react';
import { PropsRoute } from '../components/router/PropsRoute';
import { matchPath } from 'react-router';

export const mapRoutes = routes =>
    routes ? routes.map((route, index) => <PropsRoute key={index} {...route} />) : [];

/**
 * Add local before each localizableRoutes path
 * return an array with all routes prefix by a locale
 */
export const localizeRoutes = (locales, routes) =>
    locales.reduce((res, locale) => {
        const currentLocaleRoutes = routes.map(route => {
            const path = route.path ? { path: `/${locale}${route.path}` } : {};
            const to = route.to ? { to: `/${locale}${route.to}` } : {};
            return { ...route, ...path, ...to };
        });
        return [...res, ...currentLocaleRoutes];
    }, []);

/**
 * Return true if the path match the current location
 * @param {*} path the path to test
 * @param {*} location the location object inject by hoc withRouter
 */
export const isRouteActive = (path, location) =>
    path && location && matchPath(location.pathname, { path }) != null;

/**
 * Parse une query string ("?a=1&b=2") en objet { a: '1', b: '2' }
 * @param {*String} search la query string (location.search)
 */
export const getQueryParams = search =>
    search
        ? search
              .replace('?', '')
              .split('&')
              .reduce((res, cur) => {
                  const [key, value] = cur.split('=');
                  return { ...res, [key]: value };
              }, {})
        : {};

/**
 * Sérialise un objet en query string ("?a=1&b=2"), chaîne vide sans paramètre
 * @param {*Object} params les paramètres à sérialiser
 */
export const buildQueryString = params => {
    const keys = Object.keys(params).filter(
        key => params[key] !== undefined && params[key] !== ''
    );
    return keys.length ? `?${keys.map(key => `${key}=${params[key]}`).join('&')}` : '';
};



// WEBPACK FOOTER //
// ./src/utils/routeUtils.js